// /js/forms/formShowLogic.js

export function setupFormShowLogic({ prefix, formClass }) {
    const form = document.querySelector(`.${formClass}`);
    if (!form) return;
  
    const venueSelect = form.querySelector(`#${prefix}venue`) || form.querySelector(`#${prefix}venue-name`);
    const showSelect = form.querySelector(`#${prefix}show-name`);
    const dateInput = form.querySelector(`#${prefix}show-date`);
  
    const showNameWrapper = form.querySelector('.show-name');
    const dateWrapper = form.querySelector('.date-name');
    const ticketExtras = form.querySelector('.ticket-extra-fields');
    const enquiryWrapper = form.querySelector('.enquiry-message');
    const submitWrapper = form.querySelector('.button-wrapper');
  
    if (!venueSelect || !showSelect) return;
  
    venueSelect.addEventListener('change', () => {
      const venueId = venueSelect.value;
      if (!venueId) return;
  
      fetch(`/api/enquiries/shows?theatreId=${venueId}`)
        .then(response => {
          if (!response.ok) throw new Error(`Failed to fetch shows: ${response.status}`);
          return response.json();
        })
        .then(data => {
          if(showSelect) {
            showSelect.innerHTML = '<option value="">Select an option</option>';
            data.forEach(show => {
              const option = document.createElement('option');
              option.value = show.name;
              option.textContent = show.name;
              showSelect.appendChild(option);
            });
          }
  
          showNameWrapper?.classList.remove('hidden');
          enquiryWrapper?.classList.remove('hidden');
          if (!dateWrapper && !ticketExtras) submitWrapper?.classList.remove('hidden');
        })
        .catch(error => console.error('Show fetch error:', error));
    });
  
    if (showSelect && dateWrapper) {
      showSelect.addEventListener('change', () => {
        dateWrapper?.classList.remove('hidden');
      });
    }
  
    if (dateInput && ticketExtras && submitWrapper) {
      dateInput.addEventListener('change', () => {
        ticketExtras?.classList.remove('hidden');
        submitWrapper?.classList.remove('hidden');
      });
    }
}
  